import React, { Component } from 'react';
import { Modal, Button, Spin, InputNumber, Select, Input, message, Table } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import RemittanceModal from './RemittanceModal';

const Option = Select.Option;

export default class BatchMark extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],   //合并后的数据
        list: [],   //储存原始数据
        remittanceCodeList: [],
        remittanceCodeAllData: [],
    }

    show = (list) => {
        const combineData = [];  //合并后的数据
        const jdeCodeData = list.map(el => el.jdeCode);

        // //标记list中jde相同的元素的最后一项
        // const findLastIndex = (arr) => {
        //     let lastIndex = {};
        //     for (let i = 0; i < arr.length; i++) {
        //         if (lastIndex[arr[i]]) {
        //             lastIndex[arr[i]] = i; // 更新下标
        //         } else {
        //             lastIndex[arr[i]] = i; // 添加到对象中
        //         }
        //     }
        //     return lastIndex;
        // }
        // const lastJdeCodeIndex = findLastIndex(jdeCodeData);
        // for (const key in lastJdeCodeIndex) {
        //     const lastIndex = lastJdeCodeIndex[key];
        //     list[lastIndex].isLastTrem = true;
        // }
        
        //将list中的空值设为undefind
        (list || []).map(el => {
            for (let key in el) {
                if (el[key] === null) {
                    el[key] = undefined;
                }
            }
        })

        const newJdeCodeData = Array.from(new Set(jdeCodeData)) //去除重复的jde项目号
        newJdeCodeData.map((jdeCodeData) => {
            let row = {};
            let approvedAmountTotal = 0;
            let actualExpensesTotal  = 0;
            let actualExpensesTaxTotal  = 0;
            let lastExpensesTotal  = 0;
            let reimbursementNumArr = [];
            list.map(listItem => {
                if (listItem.jdeCode == jdeCodeData) {
                    const {
                        approvedAmount = 0,
                        actualExpenses = 0,
                        actualExpensesTax = 0,
                        lastExpenses = 0,
                        ptPriceStatus,
                    } = listItem;
                    //筛选出相同的报销单号
                    reimbursementNumArr.push(listItem.reimbursementNum);
                    let newReimbursementNumArr = Array.from(new Set(reimbursementNumArr));  
                    //获取合计值
                    approvedAmountTotal = approvedAmountTotal + approvedAmount;
                    actualExpensesTotal = actualExpensesTotal + actualExpenses;
                    actualExpensesTaxTotal = actualExpensesTaxTotal + actualExpensesTax;
                    lastExpensesTotal = lastExpensesTotal + lastExpenses;
                    //给行赋值
                    row.reimbursementNum = newReimbursementNumArr.join(',');
                    row.approvedAmount = Number(approvedAmountTotal.toFixed(2));
                    row.actualExpenses = Number(actualExpensesTotal.toFixed(2));
                    row.actualExpensesTax = Number(actualExpensesTaxTotal.toFixed(2));
                    if (this.booleanEquals(ptPriceStatus,['Pending','Approval_Progress','Unregistered_Payment'])) {
                        row.lastExpenses = undefined;
                    } else {
                        row.lastExpenses = Number(lastExpensesTotal.toFixed(2));
                    }

                    row.ptPriceStatus = listItem.ptPriceStatus;
                    row.statusRemark = listItem.statusRemark;
                    row.investigationName = listItem.investigationName;
                    row.customerCompanyNameCode = listItem.customerCompanyNameCode;
                    row.jdeCode = listItem.jdeCode;
                    row.actualExpensesRate = listItem.actualExpensesRate;
                    row.actualExpensesRateList = listItem.actualExpensesRateList;
                    row.remittanceApplicationIds = listItem.remittanceApplicationIds ? listItem.remittanceApplicationIds.split(',') : [];
                    row.remittanceCodes = listItem.remittanceCodes ? listItem.remittanceCodes.split(',') : [];
                    row.whetherInvPm = listItem.whetherInvPm;  //是否是项目PM
                    row.contractRate = listItem.contractRate;   //该合同税率

                }
            })
            combineData.push(row);
        });
        //获取计算比例（后续作拆分处理时要用到）
        list.map(listItem => {
            combineData.map(dataItem =>{
                if (listItem.jdeCode == dataItem.jdeCode) {
                    listItem.approvedAmountRatio = Number((listItem.approvedAmount / dataItem.approvedAmount).toFixed(8));
                }
            })
        });
        this.setState({
            list,
            data: combineData,
            visible: true,
        },() => {
            // 通过标记状态
            // this.state.data.map((el, index) =>{
            //     this.handleChange(el.ptPriceStatus, 'ptPriceStatus', index);
            // })
            //获取请款单号数据
            combineData.map(el => {
                if (el.jdeCode) {
                    this.queryRemittanceCodeAllData(el.jdeCode);
                }
            })
        });
    }

    // 获取有关请款单号的所有数据
    queryRemittanceCodeAllData= jdeCode => {
        const options = {
            method: 'POST',
            url: API_URL.contract.queryContractRemittanceList,
            data: {
                investigationJdeCode: jdeCode,
                expenseTypeId: '4',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res.data;
                const { remittanceCodeAllData } = this.state;
                const arr = [];
                datas.map(el => {
                    arr.push({
                        contractRemittanceApplicationId: el.contractRemittanceApplicationId,
                        remittanceCode: el.remittanceCode,
                        paymentProgressCode: el.paymentProgressCode,
                    });
                });
                remittanceCodeAllData.push({ 
                    jdeCode,
                    remittanceCodeList: arr,
                    remittanceCodeDatas: datas,
                });
                this.setState({
                    remittanceCodeAllData,
                })
            },
        };
        $.sendRequest(options);
    }

    //判断字段是否等于某些值
    booleanEquals = (key, value = []) => {
        return value.some((el) => key === el);
    };

    submit = () => {
        const { data, list } = this.state;
        

        //校验必填
        let noFillName = '';
        data.map(el => {
            const { ptPriceStatus, statusRemark, actualExpensesRate, lastExpenses, whetherInvPm } = el;
            const canEdit = this.booleanEquals(ptPriceStatus, ['Registered_Issue_Invoice','Invoiced_Not_Paid','Invoiced_Paid','Not_Invoiced_Paid','Clinical_Resources_Absorption','Project_Undertaking','OTHER']);
            console.log(whetherInvPm, ptPriceStatus, actualExpensesRate);
            console.log(!actualExpensesRate);
            if (!ptPriceStatus) {
                noFillName = '状态';
                return
            } else if (ptPriceStatus == 'OTHER' && !statusRemark) {
                noFillName = '其他状态说明';
                return
            } else if (whetherInvPm === 0 && ptPriceStatus != 'OTHER' && actualExpensesRate != 0 && !actualExpensesRate) {
                noFillName = '申请结算税率';
                return
            } else if (canEdit && lastExpenses != 0 && !lastExpenses) {
                noFillName = '最终结算金额（含税）';
                return
            }
        })
        if (noFillName !== '') {
            message.warning(`${noFillName}不能为空！`)
            return
        }

        //拆分处理
        data.map(dataItem => {
            //相同jde项目号相同的记录中，"申请结算金额（含税）","申请结算税费","最终结算金额（含税）"不包括最后一项的合计值
            // let exEndActualExpenses = 0;  
            // let exEndactualExpensesTax = 0;  
            // let exEndlastExpenses = 0;  
            list.map(listItem => {
                if (listItem.jdeCode == dataItem.jdeCode) {
                    // if (!listItem.isLastTrem) {
                        listItem.actualExpenses = (dataItem.actualExpenses || dataItem.actualExpenses == 0) ? Number((dataItem.actualExpenses * listItem.approvedAmountRatio).toFixed(2)) : undefined;

                        listItem.actualExpensesTax = (dataItem.actualExpensesTax || dataItem.actualExpensesTax == 0) ? Number((dataItem.actualExpensesTax * listItem.approvedAmountRatio).toFixed(2)) : undefined;

                        listItem.lastExpenses = (dataItem.lastExpenses || dataItem.lastExpenses == 0) ? Number((dataItem.lastExpenses * listItem.approvedAmountRatio).toFixed(2)) : undefined;
                        // exEndActualExpenses = exEndActualExpenses + listItem.actualExpenses;
                        // exEndactualExpensesTax = exEndactualExpensesTax + listItem.actualExpensesTax;
                        // exEndlastExpenses = exEndlastExpenses + listItem.lastExpenses;
                    // } else {
                    //     //"isLastTrem"为true,则该条记录是相同jde项目号相同的记录中的最后一条记录，其值为总计值-之前记录合计值
                        
                    //     listItem.actualExpenses = dataItem.actualExpenses ? Number((dataItem.actualExpenses - exEndActualExpenses).toFixed(2)) : undefined;
                    //     listItem.actualExpensesTax = dataItem.actualExpensesTax ? Number((dataItem.actualExpensesTax - exEndactualExpensesTax).toFixed(2)) : undefined;
                    //     listItem.lastExpenses = dataItem.lastExpenses ? Number((dataItem.lastExpenses - exEndlastExpenses).toFixed(2)) : undefined;
                    // }
                    listItem.ptPriceStatus = dataItem.ptPriceStatus;
                    listItem.statusRemark = dataItem.statusRemark;
                    listItem.remittanceCode = dataItem.remittanceCode;
                    listItem.actualExpensesRate = dataItem.actualExpensesRate;
                    listItem.remittanceApplicationIds = (dataItem.remittanceApplicationIds || []).join(',');
                    listItem.remittanceCodes = (dataItem.remittanceCodes || []).join(',');
                    listItem.paymentProgressCodes = (dataItem.paymentProgressCodes || []).join(',');
                }
            })
        });
        let sendData = {};
        list.map((listItem, listIndex) => {
            for (const key in listItem) {
                sendData[`ptPriceRecordList[${listIndex}].${key}`] = listItem[key];
            }
        });
        const options = {
            method: 'POST',
            url: API_URL.contract.markPtPriceStatus,
            data: {
                ...sendData
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.props.loadData();
            },
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            data: [],   
            list: [],   
        });
    }

    getColumns = () => {
        const columns = [{
            title: '报销单号',
            dataIndex: 'reimbursementNum',
            key: 'reimbursementNum',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 140,
        }, {
            title: '客户名称',
            dataIndex: 'customerCompanyNameCode',
            key: 'customerCompanyNameCode',
            width: 140,
        },{
            title: 'JDE项目号',
            dataIndex: 'jdeCode',
            key: 'jdeCode',
            width: 120,
        }, {
            title: '标记状态',
            dataIndex: 'ptPriceStatus',
            key: 'ptPriceStatus',
            width: 120,
            render: (text, record, index) => {
                const { statusList = [] } = this.props;
                const statusOption = statusList.map(el => <Option key={el.value} value={el.value}>{el.label}</Option>)
                return <Select
                        placeholder='请选择'
                        style={{ width: 100 }}
                        allowClear
                        value={text}
                        onChange={(value) => this.handleChange(value, 'ptPriceStatus', index)}
                    >
                        {statusOption}
                    </Select>
            }
        }, {
            title: '其他状态说明',
            dataIndex: 'statusRemark',
            key: 'statusRemark',
            width: 140,
            render: (text, record, index) => {
                const { ptPriceStatus } = record;
                return ptPriceStatus == 'OTHER' ? <Input
                        placeholder='请选择'
                        style={{ width: 120 }}
                        value={text}
                        onChange={e => this.handleChange(e.target.value, 'statusRemark', index)}
                        /> : ''
                    
            }
    
        },{
            title: 'Ariba&OA审批通过金额',
            dataIndex: 'approvedAmount',
            key: 'approvedAmount',
            width: 100,
        }, {
            title: '申请结算金额（含税）',
            dataIndex: 'actualExpenses',
            key: 'actualExpenses',
            width: 80,
        }, {
            title: '申请结算税率（%）',
            dataIndex: 'actualExpensesRate',
            key: 'actualExpensesRate',
            width: 100,
            render: (text, record, index) => {
                const { ptPriceStatus, actualExpensesRateList, whetherInvPm } = record;
                const actualExpensesRateOption = (actualExpensesRateList || []).map(el => <Option key={String(el)} value={String(el)}>{el}</Option>);
                return ptPriceStatus == 'OTHER' ? '' : (whetherInvPm == 1 ? text : <Select
                    mode="combobox"
                    filterOption={true}
                    style={{ width: 80 }}
                    // placeholder="请输入"
                    value={text}
                    onChange={value => this.handleChange(value, 'actualExpensesRate', index)}
                >
                    {actualExpensesRateOption}
                </Select>)
            }
        }, {
            title: '申请结算税费',
            dataIndex: 'actualExpensesTax',
            key: 'actualExpensesTax',
            width: 80,
        }, {
            title: '最终结算金额（含税）',
            dataIndex: 'lastExpenses',
            key: 'lastExpenses',
            width: 100,
            render: (text, record, index) => {
                const { ptPriceStatus } = record;
                
                return this.booleanEquals(ptPriceStatus,['Pending','Approval_Progress','Unregistered_Payment']) ? '' : <InputNumber
                    placeholder='请输入'
                    precision={2}
                    style={{ width: 80 }}
                    value={text}
                    onChange={value => this.handleChange(value, 'lastExpenses', index)}
                /> 
            }
        },  {
            title: '请款单号',
            dataIndex: 'remittanceApplicationIds',
            key: 'remittanceApplicationIds',
            width: 120,
            render: (text, record, index) => {
                const { ptPriceStatus, jdeCode } = record;
                const { remittanceCodeAllData } = this.state;

                let remittanceCodeList = [];  //请款单号下拉框选项数据
                let remittanceCodeDatas = [];  //请款单号弹窗数据
                remittanceCodeAllData.map(el => {
                    if (el.jdeCode == jdeCode) {
                        remittanceCodeList = el.remittanceCodeList;
                        remittanceCodeDatas = el.remittanceCodeDatas;
                    }
                })

                const canEdit = this.booleanEquals(ptPriceStatus, ['Registered_Issue_Invoice','Invoiced_Not_Paid','Invoiced_Paid','Not_Invoiced_Paid','Clinical_Resources_Absorption','Project_Undertaking','OTHER']);

                const remittanceCodeOption = (remittanceCodeList || []).map(el => <Option key={String(el.contractRemittanceApplicationId)} value={String(el.contractRemittanceApplicationId)}>{el.remittanceCode}</Option>);
                return canEdit ? <div onClick={() => this.remittanceModalRef.show(text, remittanceCodeDatas, index)}>
                    <Select
                        placeholder='请选择'
                        style={{ width: 100 }}
                        mode='multiple'
                        dropdownClassName='hiddenSelectBox'
                        allowClear
                        value={text}
                        onChange={(value) => this.handleChange(value, 'remittanceApplicationIds', index)}
                    >
                        {remittanceCodeOption}
                    </Select> 
                </div> : ''
            }
        }];
        return columns;
    }

    handleChange = (value, key, index) => { 
        const { data, remittanceCodeAllData } = this.state;
        const { approvedAmount, contractRate, actualExpensesRate, ptPriceStatus } = data[index];
        
        switch (key) {
            case 'actualExpensesRate':
                if (/[A-Za-z]/.test(value)) {
                    data[index][key] = undefined;
                } else {
                    data[index][key] = value.indexOf('.') == -1 ? value : value.replace(/(\.\d{2})\d+/, '$1'); //保留字符串小数点后两位
                    if (value) {
                        data[index].actualExpensesTax = Number((approvedAmount * Number(value) * 0.01).toFixed(2));
                        data[index].actualExpenses = Number((data[index].actualExpensesTax + approvedAmount).toFixed(2));
                    } else {
                        data[index].actualExpensesTax = undefined;
                        data[index].actualExpenses = Number(approvedAmount.toFixed(2));
                    }
                    if (this.booleanEquals(ptPriceStatus,['Pending','Approval_Progress','Unregistered_Payment'])) {
                        data[index].lastExpenses = undefined;
                    } else {
                        data[index].lastExpenses = Number(data[index].actualExpenses.toFixed(2));
                    }
                }
                break;
            case 'remittanceApplicationIds':
                let remittanceCodeList = [];
                remittanceCodeAllData.map(el => {
                    if (el.jdeCode == data[index].jdeCode) {
                        remittanceCodeList = el.remittanceCodeList;
                    }
                });
                const codeNames = [];
                const paymentProgressCodes = [];
                data[index][key] = value;
                if (value && value.length) {
                    remittanceCodeList.map(datas => {
                        value.map(id => {
                            if (datas.contractRemittanceApplicationId == id) {
                                codeNames.push(datas.remittanceCode);
                                paymentProgressCodes.push(datas.paymentProgressCode);
                            }
                        })
                    })
                }
                data[index].remittanceCodes = codeNames;
                data[index].paymentProgressCodes = Array.from(new Set(paymentProgressCodes));
                break;
            case 'ptPriceStatus':
                data[index][key] = value;
                data[index].statusRemark = undefined;
                if (value == 'OTHER') {
                    data[index].actualExpensesRate = undefined;
                    data[index].actualExpensesTax = undefined;
                    data[index].actualExpenses = Number(approvedAmount.toFixed(2));
                } else {
                    data[index].actualExpensesRate = actualExpensesRate ? actualExpensesRate : contractRate;
                    if (data[index].actualExpensesRate) {
                        data[index].actualExpensesTax = Number((approvedAmount * Number(data[index].actualExpensesRate) * 0.01).toFixed(2));
                        data[index].actualExpenses = Number((data[index].actualExpensesTax + approvedAmount).toFixed(2));
                    } else {
                        data[index].actualExpensesTax = undefined;
                        data[index].actualExpenses = Number(approvedAmount.toFixed(2));
                    }
                }
                if (!this.booleanEquals(value, ['Registered_Issue_Invoice','Invoiced_Not_Paid','Invoiced_Paid','Not_Invoiced_Paid','Clinical_Resources_Absorption','Project_Undertaking','OTHER'])) {
                    data[index].remittanceApplicationIds = [];
                }
                if (this.booleanEquals(value,['Pending','Approval_Progress','Unregistered_Payment'])) {
                    data[index].lastExpenses = undefined;
                } else {
                    data[index].lastExpenses = Number(data[index].actualExpenses.toFixed(2));
                }
                break;
            default:
                data[index][key] = value;
                break;
        }
        
        this.setState({ data });
    }

    
    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title="批量标记"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                maskClosable={false}
                width={1200}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                bodyStyle={{ maxHeight: 600 }}
            >
                <div style={{ padding: '30px 20px' }}>
                    <Spin spinning={loading}>
                        <TableC
                            data={data}
                            // scrollX={1000}
                            scrollY={300}
                            columns={this.getColumns()}
                            pagination={false}
                        />
                        <RemittanceModal
                            ref={el => this.remittanceModalRef = el}
                            onChange={this.handleChange}
                        />
                    </Spin>
                </div>
                
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/ptReimburse/BatchMark.js